import { Link } from "react-router-dom";
import { IconLOSGroup } from "../../../../common/icons/IconLOSGroup/IconLOSGroup";
import { IconEdLOSGroup } from "../../../../common/icons/IconEdLOSGroup/IconEdLOSGroup";
import { IconWatchlistGroup } from "../../../../common/icons/IconWatchlistGroup/IconWatchlistGroup";
import { IconCustomerListGroup } from "../../../../common/icons/IconCustomerListGroup/IconCustomerListGroup";
import TEALIUM from "../../../../common/enums/tealium-enums";
import { track } from "../../../../common/util/tealium";
import "./GroupNavigationTile.scss";

export enum GroupIconType {
  Los = "los",
  EdLos = "edLos",
  Watchlist = "watchlist",
  CustomerList = "customerList",
}

interface Props {
  title: string;
  iconType: GroupIconType;
  to: string;
  disabled?: boolean;
  tealiumAction?: string;
  tealiumCategory?: string;
}

const iconMap = {
  [GroupIconType.Los]: IconLOSGroup,
  [GroupIconType.EdLos]: IconEdLOSGroup,
  [GroupIconType.Watchlist]: IconWatchlistGroup,
  [GroupIconType.CustomerList]: IconCustomerListGroup,
};

export const GroupNavigationTile = ({
  title,
  iconType,
  to,
  disabled = false,
  tealiumAction,
  tealiumCategory,
}: Props) => {
  const IconComponent = iconMap[iconType];
  const disabledClass = disabled ? "group-navigation-tile--disabled" : "";

  const content = (
    <div className={`group-navigation-tile ${disabledClass}`}>
      <div className="group-navigation-tile__icon">
        <IconComponent />
      </div>
      <div className="group-navigation-tile__content">
        <h3 className="group-navigation-tile__title">{title}</h3>
      </div>
      <div className="group-navigation-tile__arrow">
        <svg
          width="10"
          height="18"
          viewBox="0 0 10 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="group-navigation-tile__chevron"
        >
          <path d="M1.5 1L9 9L1.5 17" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );

  if (to && !disabled) {
    const handleTileClick = () => {
      if (tealiumAction && tealiumCategory) {
        track(
          TEALIUM.U_TAG_METHOD.LINK,
          TEALIUM.EVENT_NAME.CLICK_ACTION,
          TEALIUM.CATEGORY.GROUP_MANAGEMENT,
          tealiumCategory,
          "",
          tealiumAction,
        );
      }
    };

    return (
      <Link
        to={to}
        className="group-navigation-tile__link"
        data-testid={`gmd-nav-tile-${iconType}`}
        onClick={handleTileClick}
      >
        {content}
      </Link>
    );
  }

  return (
    <div className="group-navigation-tile__link" data-testid={`gmd-nav-tile-${iconType}`}>
      {content}
    </div>
  );
};
